/* eslint-disable import/no-extraneous-dependencies */
import React from "react";
import { Loader as KendoLoader } from "@progress/kendo-react-indicators";

export default function Loader() {
  return (
    <div className="page-loader-container">
      <KendoLoader size="large" type="converging-spinner" />
    </div>
  );
}
